export default function JoinCta() {
  return (
    <section id="join" className="bg-background-50 px-4 md:px-6 pb-14 md:pb-20">
      <div className="mx-auto w-full max-w-[1440px] overflow-hidden rounded-2xl bg-foreground-950 px-5 md:px-10 py-10 md:py-14 relative">
        <div className="pointer-events-none absolute -right-10 -top-10 h-56 w-56 rounded-full bg-primary-500/20 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-16 left-1/3 h-56 w-56 rounded-full bg-accent-500/15 blur-3xl" />
        <div className="relative grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] gap-8 items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/20 text-primary-300 px-3 py-1 text-xs font-semibold whitespace-nowrap">
              <i className="ri-camera-lens-line" />
              51大雷 · 吃瓜情报站
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-black leading-tight text-background-50">
              你在现场？把这一秒交给我
            </h2>
            <p className="mt-3 max-w-xl text-sm md:text-base leading-relaxed text-background-50/75">
              投稿一段翻车瞬间、一条现场线索，或只是想蹲更新的吃瓜同好——来情报站冒个泡。这里不收门槛，只收名场面。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-background-50/70">
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-live-line text-accent-400" />
                每日 87 条实录更新
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-team-line text-accent-400" />
                9,400+ 位吃瓜成员
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-shield-check-line text-accent-400" />
                静态演示 · 无需登录
              </span>
            </div>
          </div>

          <form
            onSubmit={(e) => e.preventDefault()}
            className="rounded-xl border border-background-50/15 bg-background-50/5 p-5 md:p-6 backdrop-blur-sm"
          >
            <label className="text-sm font-semibold text-background-50">投一条线索</label>
            <p className="mt-1 text-xs text-background-50/60">聊聊你在现场看到的那一幕。</p>
            <div className="mt-4 flex flex-col sm:flex-row gap-2.5">
              <input
                type="text"
                name="scene"
                placeholder="例如：街头挑战 100 秒又双叒崩了"
                className="w-full flex-1 rounded-md bg-background-50 text-foreground-950 placeholder:text-foreground-400 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-accent-400"
              />
              <button
                type="button"
                className="inline-flex shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 hover:bg-primary-400 cursor-pointer"
              >
                提交线索
                <i className="ri-send-plane-line" />
              </button>
            </div>
            <div className="mt-3 text-[11px] text-background-50/50">
              仅做页面演示，不会真的对外发送或收集信息。
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}